import { useState } from "react";

const Location = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section id="location" className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#090C6A]">
            Kamdhenu Conquest Location Advantage
          </h2>
          <div className="w-24 h-1 bg-[#090C6A] mx-auto mt-3 rounded"></div>
        </div>

        {/* Content */}
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Map */}
          <div className="w-full lg:w-1/2 rounded-lg overflow-hidden shadow-md">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.9726840106464!2d72.99263627520509!3d19.06493858213734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c10035a18cb7%3A0xb3877f4b8894c140!2sKamdhenu%20Conquest%20Vashi!5e0!3m2!1sen!2sin!4v1772433364921!5m2!1sen!2sin"
              width="100%"
              height="350"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Location Map"
            ></iframe>
          </div>

          {/* Connectivity */}
          <div className="w-full lg:w-1/2">
            <div className="space-y-2">
              {data.connectivityData.map((item, index) => {
                const isOpen = activeIndex === index;

                return (
                  <div
                    key={index}
                    className={`group rounded-2xl border transition-all duration-300 
              ${isOpen ? "border-[#090C6A] shadow-xl" : "border-gray-200 shadow-sm"}
            `}
                  >
                    <button
                      onClick={() => setActiveIndex(isOpen ? null : index)}
                      className="w-full flex justify-between items-center p-2 text-left"
                    >
                      <div>
                        <h4 className="font-semibold text-lg text-gray-900 group-hover:text-[#090C6A] transition">
                          {item.title}
                        </h4>
                        <p className="text-xs text-gray-500">
                          Click to view connectivity details
                        </p>
                      </div>

                      {/* Modern Toggle Icon */}
                      <div
                        className={`w-9 h-9 flex items-center justify-center rounded-full border transition-all duration-300 
                  ${isOpen ? "bg-[#090C6A] text-white rotate-180" : "bg-white text-gray-700"}
                `}
                      >
                        +
                      </div>
                    </button>

                    {/* Animated Expand Section */}
                    <div
                      className={`grid transition-all duration-300 ease-in-out 
                ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}
              `}
                    >
                      <div className="overflow-hidden px-6 pb-5">
                        <ul className="space-y-2 text-gray-600 text-sm list-disc list-inside">
                          {item.items.map((point, i) => (
                            <li key={i}>{point}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
